export default __webpack_public_path__ + "static/media/linkedin_logo.a3457346.svg";